import React from 'react';
import cx from 'classnames';

import styles from './BlockHeader.module.scss';

import Text, { TextProps } from '../../atoms/Text';
import Button, { ButtonProps } from '../../atoms/Button';

export type BlockHeaderTypeType = 'WithButton' | 'Default';

export const defaultProps = {
  type: 'Default' as BlockHeaderTypeType,
  text: {
    type: 'Title1',
    style: 'Dark',
    size: 'Medium',
    align: 'Left',
    value: 'Block header',
  } as TextProps,
  button: {
    type: 'TextButton',
    size: 'Large',
    fill: 'Colour',
    colour: 'Brand',
    text: {
      type: 'Subtitle1',
      style: 'White',
      size: 'Medium',
      align: 'Center',
      value: 'Large',
    },
  } as ButtonProps,
};

export type BlockHeaderProps = {
  type?: BlockHeaderTypeType;
  text?: TextProps;
  button?: ButtonProps;
  className?: string;
};

const BlockHeader: React.FC<BlockHeaderProps> = ({
  type,
  text,
  button,
  className,
}) => {

  const currentStyle = styles[`blockHeader${type}`];

  const textView = (
    <Text
      className={styles.text}
      {...text} />
  );
  
  let buttonView;
  
  switch (type) {
    case 'WithButton':
      buttonView = (
        <Button
          className={styles.button}
          {...button} />
      );
      break;
    case 'Default':
      break;
  }

  return (
    <div className={cx(currentStyle, className)}>
      {textView}
      {buttonView}
    </div>
  );
};

BlockHeader.defaultProps = defaultProps;

export default BlockHeader;
